
import { Component, Vue, Watch } from 'vue-property-decorator';
import random from 'lodash';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState(['isLoadingGlobal']),
  },
})
export default class GlobalLoader extends Vue {
  public isLoadingGlobal: boolean;
  private defaultDuration = 10000;
  private defaultInterval = 800; // update frequently
  private variation = 0.5; // grow interval (0 - 1)
  private startingPoint = 0;
  public endingPoint = 97;
  public progress = this.startingPoint;
  public timeoutId?: ReturnType<typeof setTimeout> = undefined;

  private loop() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    if (this.progress >= this.endingPoint) {
      return;
    }
    const size = (this.endingPoint - this.startingPoint) / (this.defaultDuration / this.defaultInterval);
    const p = Math.round(this.progress + random(size * (1 - this.variation), size * (1 + this.variation)));
    this.progress = Math.min(p, this.endingPoint);
    this.timeoutId = setTimeout(
      this.loop,
      random(this.defaultInterval * (1 - this.variation), this.defaultInterval * (1 + this.variation)),
    );
  }

  private start() {
    this.progress = this.startingPoint;
    this.loop();
  }

  private stop() {
    this.progress = 100;
    clearTimeout(this.timeoutId);
  }

  @Watch('isLoadingGlobal')
  private onGlobalLoading() {
    this.isLoadingGlobal ? this.start() : this.stop();
  }
}
